<template>
  <div class="header w-100vw" :style="'background: url('+bannerSrc+') no-repeat center; background-size: cover;'">
    <div class="nav w-1400px">
      <img class="logo" src="../assets/logo.png" alt="">
      <div class="menuToggle" @click="toggleMenu" :class="{open: menuOpen}">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="navItems" :class="{open: menuOpen}">
        <div v-for="(item,index) in navList" :key="index" :class="[{'on':navCur==index},'item']" @click.stop="changeNav(index,item.link)">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      navList:[],
      navCur: "",
      bannerSrc:"",
      menuOpen: false
    }
  },
  created () {
    this.navList = this.$store.state.navList;
    this.navCur=this.$store.state.navCur;
    this.bannerSrc = require(`../assets/banner/banner${this.navCur}.png`)
  },
  computed: {
    watchNavCur() {
      return this.$store.state.navCur;
    }
  },
  watch: {
    watchNavCur(newValue, oldValue) {
      this.navCur=newValue;
      this.bannerSrc = require(`../assets/banner/banner${newValue}.png`)
      this.menuOpen = false;
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    changeNav(index,link) {
      this.navCur=index;
      this.$store.commit('changeNavCur', index);
      this.bannerSrc = require(`../assets/banner/banner${index}.png`)
      this.$router.push({ name: link })
      this.menuOpen = false;
    }
  },
};
</script>

<style scoped lang="scss">
.header {
   width: 100vw;
   height: 80vh;
   background-size: cover!important;
  .nav {
    height: 40px;
    position: absolute;
    left: 0;
    top: 30px;
    right: 0;
    margin: auto;
    display: flex;
    align-items: center;

    .logo{
      width: 86px;
      margin-right: auto;
      flex-shrink: 0;
    }

    .menuToggle{
      display: none;
      flex-direction: column;
      justify-content: space-between;
      width: 24px;
      height: 18px;
      cursor: pointer;
      z-index: 100;
      position: relative;

      span {
        display: block;
        width: 100%;
        height: 2px;
        background: #fff;
        transition: all .3s ease;
        border-radius: 1px;
      }

      &.open {
        span:nth-child(1) {
          transform: translateY(8px) rotate(45deg);
        }
        span:nth-child(2) {
          opacity: 0;
        }
        span:nth-child(3) {
          transform: translateY(-8px) rotate(-45deg);
        }
      }
    }

    .navItems {
      display: flex;
      align-items: center;
      gap: 0;

      .item{
        font-size: 20px;
        color: #fff;
        padding: 0 28px;
        height: 40px;
        display: inline-flex;
        align-items: center;
        border-bottom: 1px solid rgba(255,255,255,0);
        transition: all .25s linear;
        white-space: nowrap;

        &:hover{
          font-weight: bold;
          cursor: pointer;
          border-bottom: 1px solid #fff;
        }
        &.on{
          font-weight: bold;
          cursor: pointer;
          border-bottom: 1px solid #fff;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 60vh;

    .nav {
      top: 15px;
      padding: 0 15px;

      .logo{
        width: 60px;
        margin-right: 0;
      }

      .menuToggle{
        display: flex;
      }

      .navItems{
        position: fixed;
        top: 0;
        right: -100%;
        width: 70%;
        max-width: 300px;
        height: 100vh;
        background: rgba(0,0,0,0.95);
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        transition: right .3s ease;
        z-index: 99;

        &.open{
          right: 0;
        }

        .item{
          font-size: 18px;
          padding: 12px 20px;
          height: auto;
          border-bottom: none;

          &:hover{
            border-bottom: none;
            color: #ae1e26;
          }
          &.on{
            border-bottom: none;
            color: #ae1e26;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .header {
    height: 50vh;

    .nav {
      top: 10px;

      .logo{
        width: 50px;
      }
    }
  }
}
</style>
